/**
 * Lista koncertów jest zarządzana w panelu WordPressa na sklep.potock.pl
 * (typ treści "Koncerty" + pola ACF, wtyczka mu-plugins/potock-koncerty.php).
 *
 * Strona pobiera ją dwa razy: raz przy buildzie (żeby treść była w HTML-u dla
 * wyszukiwarek) i raz po załadowaniu w przeglądarce (żeby zmiany w panelu były
 * widoczne bez przebudowy strony).
 */
module.exports = {
  KONCERTY_API_URL: 'https://sklep.potock.pl/wp-json/potock/v1/koncerty',
};
